import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { GateWay, Category } from '../gateway.model';
import { GateWayTrapActionTypes, GateWayTrapActions } from '../actions/gateway-trap.actions';

export interface State extends EntityState<GateWay> {
  // additional entities state properties
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export interface GateWayMgtTrapDetailState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialMgtTrapDetailState: GateWayMgtTrapDetailState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface GateWayTrapDetailState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialTrapDetailState: GateWayTrapDetailState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function mgtTrapDetailReducer(state = initialMgtTrapDetailState, action: GateWayTrapActions): GateWayMgtTrapDetailState {
  switch (action.type) {
    case GateWayTrapActionTypes.ReadMgtTrapDetail:
      return {...state, Loaded: false, Loading: true};

    case GateWayTrapActionTypes.UpsertMgtTrapDetail:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayTrapActionTypes.ReadMgtTrapDetailFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export function trapDetailReducer(state = initialTrapDetailState, action: GateWayTrapActions): GateWayTrapDetailState {
  switch (action.type) {
    case GateWayTrapActionTypes.ReadTrapDetail:
      return {...state, Loaded: false, Loading: true};

    case GateWayTrapActionTypes.UpsertTrapDetail:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case GateWayTrapActionTypes.ReadTrapDetailFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export const getGateWayMgtTrapDetailState = (state: GateWayMgtTrapDetailState) => state;
export const getGateWayTrapDetailState = (state: GateWayTrapDetailState) => state;
